import * as React    from "react";
import {cx}          from "emotion";

import './button.scss';

import {cs} from "@Common/react/chain-services";

export const Button = ({id=null, btnName, btnClassName, disabled=false, onClick=null, type=null, xdQaName=null, extraInfo={}}) => cs(
    () => (
        <button id={id} type={type} className={cx("button-786",btnClassName)} disabled={disabled} onClick={onClick} xd-qa-type="button" xd-qa-name={xdQaName} {...extraInfo}>{btnName}</button>
    )
);